<template>
    <div v-show="showQuickDirectory" class="window-background dialog-window" @pointerover="handlePointerOver"
        @pointerleave="handlePointerLeave" @pointerenter="handlePointerEnter">
        <div class="page-item" v-show="getLastLessonData" @click="handleJumpPage(getLastLessonData.pageIndex)"> 上一課
        </div>
        <div class="page-item" v-for="data of getPageItemsData" :key="data.pageName"
            @click="handleJumpPage(data.pageIndex)">
            {{ data.pageName }}</div>
        <div class="page-item" v-show="getNextLessonData" @click="handleJumpPage(getNextLessonData.pageIndex)"> 下一課
        </div>
        <hr class="page-hr" />
        <input class="page-input" v-model.lazy="message" type="text" placeholder="請輸入頁碼" />
        <button class="confirmBtn" @click="handleJumpPageByName">
            <span>確認</span>
        </button>
    </div>
</template>

<script>
import { store } from "../store";
import { quickDirectoryStore } from '../js/store/quickDirectoryStore';
import { focusStore } from "../js/store/nowFocusStore";
import EventBus from "../js/event_bus";

export default {
    name: "QuickDirectory",
    data: function () {
        return {
            show: false,
            store,
            message: ""
        }
    },
    watch: {
        watchToClose: {
            handler: function () {
                this.show = false;
            }
        }
    },
    methods: {
        handleJumpPage(pageIndex) {
            window.pageControl.gotoPage(pageIndex);
        },
        handleJumpPageByName() {
            window.pageControl.gotoPageByName(this.message);
        },
        closeDirectory() {
            EventBus.getInstance().emit("close_quick_directory");
        },
        handlePointerOver() {
            focusStore.setFocusQuickDirectory(true);
        },
        handlePointerLeave() {
            focusStore.setFocusQuickDirectory(false);
        },
        handlePointerEnter() {
            focusStore.setFocusQuickDirectory(true);
        },
        switchQuickDirectory(show) {
            if (show === undefined) {
                this.show = !this.show;
            } else {
                this.show = show;
            }
        }
    },
    computed: {
        getLastLessonData() {
            if (store.nowDirectoryTag) {
                let directoryMap = quickDirectoryStore.data[store.nowDirectoryTag][store.nowPage] || null;
                if(!directoryMap) return;
                let pageContent = store.pageContent[store.nowDirectoryTag];
                let lastLesson = quickDirectoryStore.data[store.nowDirectoryTag][directoryMap[0] - 1];

                if (lastLesson) {
                    return {
                        pageIndex: lastLesson[0],
                        pageName: pageContent[lastLesson[0]].pageName,
                        files: pageContent[lastLesson[0]].files
                    };
                }
            }
            return null;
        },
        getNextLessonData() {
            if (store.nowDirectoryTag) {
                let directoryMap = quickDirectoryStore.data[store.nowDirectoryTag][store.nowPage] || null;
                if(!directoryMap) return;
                let pageContent = store.pageContent[store.nowDirectoryTag];
                let nextLesson = quickDirectoryStore.data[store.nowDirectoryTag][directoryMap[directoryMap.length - 1] + 1];

                if (nextLesson) {
                    return {
                        pageIndex: nextLesson[0],
                        pageName: pageContent[nextLesson[0]].pageName,
                        files: pageContent[nextLesson[0]].files
                    };
                }
            }
            return null;
        },
        getPageItemsData() {
            if (store.nowDirectoryTag) {
                let result = [];
                let directoryMap = quickDirectoryStore.data[store.nowDirectoryTag][store.nowPage] || null;
                if(!directoryMap) return;
                let pageContent = store.pageContent[store.nowDirectoryTag];

                for (let i = 0; i < directoryMap.length; i++) {
                    result.push({
                        pageIndex: directoryMap[i],
                        pageName: pageContent[directoryMap[i]].pageName,
                        files: pageContent[directoryMap[i]].files
                    });
                }
                return result;
            }
            return [];
        },
        watchToClose() {
            return `${store.nowPage}|${store.singlePageIndex}`
        },
        directoryMap() {
            return quickDirectoryStore.data[store.nowDirectoryTag][store.nowPage] || null;
        },
        showQuickDirectory() {
            return this.show && this.directoryMap;
        }
    }
}
</script>

<style scoped>
.confirmBtn span {
    font-size: 20px;
    color: white;
    line-height: 20px;
}

.confirmBtn {
    position: relative;
    height: 40px;
    width: 100px;
    background-color: #03b5a5;
    border-style: none;
    border-radius: 30px;
    transform: translate(15%, -15%);
}

.page-input {
    position: relative;
    font-size: 25px;
    font-weight: normal;
    font-family: 微軟正黑體;
    text-align: center;
    background-color: rgb(255, 255, 255, 0);
    width: 55%;
    transform: translateY(-10%);
    margin-top: 10px;
    margin-bottom: 10px
}

.page-hr {
    height: 0px;
    background-color: rgb(0, 89, 173);
    border-width: 3px;
    border-style: solid;
    border-color: rgb(0, 89, 173);
}

.page-item {
    user-select: none;
    font-size: 20px;
    color: rgb(255, 255, 255);
    font-weight: bold;
    font-family: 微軟正黑體;
    text-align: center;
    line-height: 40px;
    background-color: rgb(150, 150, 150);
    display: inline-block;
    width: fit-content;
    height: 40px;
    margin: 10px;
    cursor: pointer;
    border-radius: 10px;
    padding-left: 10px;
    padding-right: 10px;
    transform: translateY(10%);
}

.dialog-window {
    position: absolute;
    z-index: var(--z-index-directory);
    margin: auto;
    left: 0px;
    right: 0px;
    bottom: max(75px, 11%);
    margin-bottom: 0px;
}

.window-background {
    background-color: rgb(255, 255, 255);
    border-radius: 30px;
    border-width: 5px;
    border-style: solid;
    border-color: rgb(0, 89, 173);
    text-align: center;
    display: table;
    transform-origin: bottom center;
    transform: scale(1);
    line-height: 0px;
    width: fit-content;
    max-width: 550px;
}
</style>